import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import DefListColumn from '../DefListColumn';
import messages from './messages';

const TransferPanelCreditDetails = ({
  contraAccount,
  type,
  accountSideDescription,
  contraAccountSideDescription,
}) => (
  <div className={styles.rightPane}>
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.creditType} />}
      data={type}
      dataTestHandle="creditDetails__feeType"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.creditContraAccount} />}
      data={contraAccount}
      dataTestHandle="creditDetails__feeContraAccount"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.accountSideDescription} />}
      data={accountSideDescription.map((description, index) => (index === 0 ? description : <div>{description}</div>))}
      dataTestHandle="creditDetails__accountSideDescription"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.contraAccountSideDescription} />}
      data={contraAccountSideDescription.map((description, index) => (index === 0 ? description : <div>{description}</div>))}
      dataTestHandle="creditDetails__contraAccountSideDescription"
    />
  </div>
);

TransferPanelCreditDetails.propTypes = {
  contraAccount: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  accountSideDescription: PropTypes.array.isRequired,
  contraAccountSideDescription: PropTypes.array.isRequired,
};

export default TransferPanelCreditDetails;



// WEBPACK FOOTER //
// ./src/components/TransferPanelCreditDetails/index.js